//Library Imports
import { connect, useSelector } from "react-redux";
import { useState, useEffect, useRef } from "react";
import React from "react";
import { Select, Popover, Dropdown } from "antd";

// application components goes here
import AccountSearch from "../../Content/MyAccounts/Components/AccountSearch";
import { ICampaignItem } from "modules/Content/interfaces";
import DropdownArrow from "../../../assets/img/icons/dropdownarrow.svg";
import { ReactComponent as SearchIcon } from "../../../assets/img/icons/search.svg";
import { ReactComponent as SearchCross } from "../../../assets/img/icons/SearchCross.svg";

// styles goes here
import styled from "styled-components";
import { ICampaignsName } from "modules/Campaigns/interfaces";
import { resetCampaignsNamesOnly } from "../../Campaigns/CampaignAssets/actions";
import InfiniteLoader from "modules/Common/Components/InfiniteLoader";
type CustomSelectAssetProps = {
  setCampaignName?: (value: string) => void;
  setCampaignId?: (value: number) => void;
  campaignName?: string;
  campaigns_list: ICampaignsName[];
  onClickCreateCampaign?: (value: any) => void;
  setSelectedCampaign?: any;
  campaign_id?: number;
  assetId?: any;
  setNewCampaign?: (value: boolean) => void;
  setSelectedValue?: (value: string) => void;
  newCampaign?: boolean;
  selectedValue?: string;
  inList?: boolean;
  listsData?: any[];
  listDataNamesLoading?: boolean;
  loadMore?: any;
  loadingCampaigns?: boolean;
  handleSearchCampaign?: (value: string) => void;
  isCampaignDropDown?: boolean;
};

const CustomSelectAsset: React.FC<CustomSelectAssetProps> = (props: CustomSelectAssetProps) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const selectRef = useRef<HTMLDivElement>(null);
  const customSelectRef = selectRef?.current;

  const [searchValue, setSearchValue] = useState("");
  const [campaignsList, setCampaignsList] = useState(props.campaigns_list);
  const [lists, setLists] = useState(props.listsData);

  const loadMore = props.loadMore;
  const loadingCampaigns = props.loadingCampaigns;
  const handleSearchCampaign = props.handleSearchCampaign;
  const isCampaignDropDown = props.isCampaignDropDown;

  const cleanSearchField = () => {
    setSearchValue("");
    // reset Campaigns Names and loadMore;
    resetCampaignsNamesOnly();
    setCampaignsList([]);
    if (loadMore) loadMore(true);
    setLists(props.listsData);
    if (handleSearchCampaign) {
      handleSearchCampaign("");
    }
  };

  const stopClickEvent = (e: any) => {
    e.stopPropagation();
  };

  const searchCampaigns = (e: any) => {
    if (e.target.value.length === 0) {
      cleanSearchField();
      if (handleSearchCampaign) {
        handleSearchCampaign("");
      }
    }
    e.stopPropagation();
    setSearchValue(e.target.value);
  };

  const handleSearch = (e: any) => {
    if ((e.which === 13 || e.which === 97) && e.target.value.trim().length > 0) {
      if (isCampaignDropDown) {
        if (handleSearchCampaign) {
          handleSearchCampaign(e.target.value);
        }
      } else {
        search(e.target.value);
      }
    }
  };

  const search = (value: string) => {
    if (value === "") {
      setCampaignsList(props.campaigns_list);
      setLists(props.listsData);
    }
    if (props?.campaigns_list && props?.campaigns_list.length > 0 && isCampaignDropDown) {
      const filtered =
        props?.campaigns_list &&
        props?.campaigns_list?.filter((item) => {
          if (item.name.toLowerCase().indexOf(value.toLowerCase()) > -1) {
            return item;
          }
        });
      setCampaignsList(filtered);
    }
    if (props?.listsData && props?.listsData.length > 0) {
      const filteredLists =
        props?.listsData &&
        props?.listsData?.filter((item) => {
          if (item.list_name.toLowerCase().indexOf(value.toLowerCase()) > -1) {
            return item;
          }
        });
      setLists(filteredLists);
    }
  };

  const selectCampaign = (e: any) => {
    // select any campaign from dropdown
    e.stopPropagation();
    props.setSelectedValue && props.setSelectedValue(e.target.innerHTML);
    if (props.setSelectedCampaign) {
      // console.log(e.target);
      // console.log(e.target.getAttribute("data-value"));
      props.setSelectedCampaign(e.target.getAttribute("data-value"));
    }
    props.setNewCampaign && props.setNewCampaign(false);
    props.setCampaignName && props.setCampaignName(e.target.textContent);
    props.setCampaignId && props.setCampaignId(Number(e.target.attributes["data-value"].value));
    try {
      setOpenDropdown(!openDropdown);
      customSelectRef?.classList.remove("open");
    } catch (e: any) {
      console.log("couldn't close the popup", e?.toString());
    }
  };

  useEffect(() => {
    // bind click events on campaign dropdown
    window.addEventListener(".campaigns-list click", function (e: any) {
      if (!customSelectRef?.contains(e.target)) {
        customSelectRef?.classList.remove("open");
      }
      console.log(customSelectRef);
    });
    setCampaignsList(props.campaigns_list);
    setLists(props.listsData);
    // console.log(props.listsData);
    return () => {
      window.removeEventListener("click", function (e: any) {
        if (!customSelectRef?.contains(e.target)) {
          customSelectRef?.classList.remove("open");
        }
        console.log(customSelectRef);
      });
    };
    // don't forget to remove the event listerners when the component unmounts
  }, [props.campaigns_list, props.listsData]);

  return (
    <StyleWrapper>
      <div className="custom-select-wrapper" onClick={() => setOpenDropdown(!openDropdown)}>
        <div ref={selectRef} className={`campaigns-list custom-select ${openDropdown ? "open" : ""} `}>
          <div className="custom-select__trigger">
            <span>{props.selectedValue ? props.selectedValue : "Please select..."}</span>
          </div>
          <div>
            <div className="arrow-dropdown">
              <img src={DropdownArrow} />
            </div>
          </div>

          <div className="custom-options">
            <div className="search-field padding-sm" onClick={(e) => stopClickEvent(e)}>
              <div className="search-wraper">
                <div className="search-bar">
                  <span className="refresh-search">
                    <SearchIcon />
                  </span>

                  <input
                    type="text"
                    name="search"
                    className="search-input"
                    placeholder={props.inList ? "Search lists" : "Search campaigns"}
                    idprefix="campaigns-02"
                    value={searchValue}
                    onChange={(e) => {
                      searchCampaigns(e);
                    }}
                    onKeyUp={(e) => handleSearch(e)}
                  />
                  {searchValue ? (
                    <span onClick={() => cleanSearchField()} className="clear-search">
                      <SearchCross />
                    </span>
                  ) : null}
                </div>
              </div>
            </div>

            <div
              className="new-campaign padding-md"
              onClick={(e) => props.onClickCreateCampaign && props.onClickCreateCampaign(e)}
            >
              <h3 className="p-0">{props.inList ? "Create new list" : "Create new campaign"}</h3>
            </div>

            {props.listDataNamesLoading ? (
              <span className="fetch-text padding-md">Fetching lists...</span>
            ) : (
              <InfiniteLoader
                dataLength={campaignsList?.length}
                next={() => loadMore && loadMore()}
                hasMore={true}
                scrollableTarget={`save-campaign-list${props.assetId ? "-" + props.assetId : ""}`}
                loader={
                  loadingCampaigns ? <span className="fetch-text padding-md">Fetching campaigns...</span> : <></>
                }
              >
                <ul
                  className="select-options padding-bottom-md scrollable scrollableCustom"
                  id={`save-campaign-list${props.assetId ? "-" + props.assetId : ""}`}
                >
                  {window.location.pathname.includes("lists/view") ||
                    window.location.pathname.startsWith("/audiences/people") ? (
                    lists && lists.length > 0 ? (
                      lists?.map((list, index: number) => (
                        <li
                          key={list.list_id}
                          onClick={(e) => selectCampaign(e)}
                          className="padding-md"
                          style={{ paddingBottom: "0px" }}
                          data-value={list.list_id}
                        >
                          {list.list_name}
                        </li>
                      ))
                    ) : (
                      <li className="padding-md disable" style={{ paddingBottom: "0px" }}>
                        {"No list found!"}
                      </li>
                    )
                  ) : null}
                  {campaignsList &&
                    campaignsList?.map((campaign: ICampaignsName, index: number) => (
                      <li
                        key={campaign.campaign_id}
                        onClick={(e) => selectCampaign(e)}
                        className="padding-md"
                        style={{ paddingBottom: "0px" }}
                        data-value={campaign.campaign_id}
                      >
                        {campaign.name}
                      </li>
                    ))}
                </ul>
              </InfiniteLoader>
            )}
          </div>
        </div>
      </div>
      {
        props.newCampaign ? (
          <div className="padding-top-sm">
            <input
              placeholder="Enter campaign name here"
              type="text"
              className="assetInput"
              id="input_campaign_name"
              onChange={(e: React.FormEvent<HTMLInputElement>) => {
                props.setCampaignName && props.setCampaignName(e.currentTarget.value);
              }}
              value={props.campaignName !== "TEMP_CAMPAIGN" ? props.campaignName : ""}
            />
          </div>
        ) : (
          ""
        )
      }
    </StyleWrapper >
  );
};

export default CustomSelectAsset;

const { Option } = Select;

const ArrowIcon = (
  <div
    style={{
      height: "22px",
      paddingLeft: "8px",
      paddingTop: "4px",
      paddingRight: "8px",
      borderLeft: "solid 1px #DDDDDD",
    }}
  >
    <img src={DropdownArrow} />
  </div>
);

const StyleWrapper = styled.div`
  width: 100%;
  .disable {
    pointer-events: none;
  }
  .fetch-text {
    font-size: 12px;
    font-weight: 600;
    font-family: "Roboto";
    color: #7e7e7e;
  }
  .search-wraper {
    position: relative;
    width: 100%;
    .search-results {
      border-radius: 22px;
      position: absolute;
      top: -80px;
      left: 0;
      // display: none;
      float: left;

      width: 100%;
      border: 1px solid #dadada;
      box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.12);
      overflow: hidden;
      transition: 0.5s;
      z-index: -1;
      opacity: 0;
      visibility: hidden;
      &.show {
        opacity: 1;
        z-index: 1;
        visibility: visible;
      }
      ul.results-list {
        background: #fff;
        padding: 30px 55px 10px 55px;
        margin: 0;
        list-style: none;
        float: left;
        display: block;
        width: 100%;
        transition: 0.5s;
        li {
          color: #5e7079;
          font-size: 16px;
          line-height: 34px;
          padding: 0;
          list-style: none;
          float: left;
          width: 100%;
          display: block;
          cursor: pointer;
          transition: 0.5s;
        }
      }
      .relevant-theme,
      .relevant-company {
        border-top: 1px solid #dadada;
        padding: 10px 40px 30px 40px;
        background: #f7f7f7;
        float: left;
        width: 100%;
        transition: 0.5s;
        h3 {
          margin-bottom: 10px;
          color: #424b50;
          font-weight: 400;
          font-family: "Roboto Slab", serif;
          font-size: 18px;
          line-height: 34px;
        }
      }
      .search-hint {
        background: #def6e6;
        padding: 18px 25px 36px 25px;
        border-radius: 22px 22px 0 0;
        float: left;
        width: 100%;
        svg {
          float: left;
          width: 35px;
          height: 39px;
        }
        ul {
          margin: 0;
          float: left;
          li {
            color: #09a43a;
            font-size: 14px;
            font-weight: 400;
            list-style: none;
            strong {
              font-weight: 700;
            }
          }
        }
      }
    }
    .search-bar {
      border-radius: 27px;
      background: #ffffff;
      border: 1px solid #dadada;
      display: block;
      float: left;
      width: 100%;
      overflow: hidden;
      position: relative;
      span.clear-search {
        float: right;
        margin-top: 5px;
        margin-right: 12px;
        transition: 0.5s;
        cursor: pointer;
        width: auto;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin-top: 3px;
          margin-right: 8px;
        }
        svg {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 10px;
          }
        }
      }
      span.refresh-search {
        padding-right: 5px;
        border-right: 1px solid #dadada;
        margin: 6px 8px;
        float: left;
        cursor: pointer;
        width: auto;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin: 3px 7px 3px 7px;
          line-height: 12px;
        }
        svg {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 10px;
          }
        }
        svg path {
          fill: #424b50;
        }
      }
      .search-input {
        float: left;
        border: none;
        outline: none;
        width: calc(100% - 90px);
        display: block;
        color: #424b50;
        font-weight: 400;
        font-size: 14px;
        margin-top: 3px;
        margin-bottom: 2px;
        font-family: "robotoregular";
        -webkit-box-shadow: 0 0 0 30px white inset !important;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 10px;
          margin-top: 3px;
        }
        &::-webkit-input-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:-moz-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &::-moz-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:-ms-input-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:hover,
        &:active,
        &:focus {
          border: none;
          outline: none;
        }
      }
    }
  }
  .scrollableCustom {
    overflow: scroll;
    overflow-x: hidden;
    /* @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 110px;
    } */
    scrollbar-width: thin;
    scrollbar-color: #001760 transparent;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-top: 10px;
      margin-bottom: 15px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
  .assetInput {
    width: 100%;
    border: solid 1px #dadada;
    padding: 5px 12px;
    font-size: 16px;
    color: #7e7e7e;
    font-family: "robotomedium", sans-serif;
    border-radius: 8px;
    &:focus,
    &:active {
      outline: none;
    }
  }
  .custom-select-wrapper {
    position: relative;
    user-select: none;
    width: 100%;
  }
  .custom-select {
    position: relative;
    display: flex;
    flex-direction: column;
    border-width: 0;
    border-style: solid;
  }
  .custom-select__trigger {
    position: relative;
    /* display: flex; */
    /* align-items: center;
    justify-content: space-between; */
    /* padding: 0 22px 10px 22px; */
    height: 44px;
    line-height: 28px;
    background: #ffffff;
    cursor: pointer;
    border: solid 1px #dadada;
    padding: 8px 35px 8px 15px;
    font-size: 16px;
    color: #7e7e7e;
    font-family: "robotomedium", sans-serif;
    border-radius: 8px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      padding: 7px 35px 7px 10px;
      line-height: 12px;
      height: 30px;
      border-radius: 6px;
    }
    span {
      overflow: hidden;
      width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .arrow-dropdown {
    position: absolute;
    top: 10px;
    right: 4px;
    height: 22px;
    padding-left: 8px;
    padding-top: 0;
    padding-right: 8px;
    border-left: solid 1px #dddddd;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      top: 7px;
      height: 15px;
      line-height: 14px;
    }
  }
  .custom-options {
    background-color: #fff;
    position: absolute;
    display: block;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    transition: all 0.5s;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    z-index: 999;
    border-radius: 8px;
    border: solid 1px #dadada;
    padding-bottom: 1em;
    /* @media all and (max-height: 850px) {
      top: auto;
      bottom: calc(100% + 5px);
    } */
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 6px;
    }
    .search-field {
      display: flex;
      flex: 1;
      background-color: #f7f7f7;
      border-radius: 8px;
    }
    .new-campaign {
      border-top: 1px solid #dadada;
      border-bottom: 1px solid #dadada;
      cursor: pointer;
      h3 {
        margin: 0;
        font-size: 16px;
        color: #7e7e7e;
        font-family: "robotomedium", sans-serif;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 12px;
        }
      }
    }
    .select-options {
      list-style-type: none;
      margin: 0;
      padding: 0;
      min-height: 10px;
      max-height: 110px !important;
      li {
        font-family: "robotomedium", sans-serif;
        font-size: 16px;
        line-height: 1.2;
        color: #7e7e7e;
        cursor: pointer;
        transition: 0.5s;
        /* width: 460px; */
        width: calc(100% - 5px);
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 1em;
        &:hover {
          /* margin-left: 5px;
          transition: 0.5s; */
          color: #27ce0a;
          cursor: pointer;
        }
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 12px !important;
          line-height: 14px;
        }
      }
    }
  }
  .custom-select.open .custom-options {
    opacity: 1;
    visibility: visible;
    pointer-events: all;
  }
  .custom-option {
    position: relative;
    display: block;
    font-size: 22px;
    font-weight: 300;
    color: #3b3b3b;
    line-height: 60px;
    cursor: pointer;
    transition: all 0.5s;
  }
  .custom-option:hover {
    cursor: pointer;
    background-color: #b2b2b2;
  }
  .custom-option.selected {
    color: #ffffff;
    background-color: #305c91;
  }

  .arrow {
    position: relative;
    height: 15px;
    width: 15px;
  }
  .arrow::before,
  .arrow::after {
    content: "";
    position: absolute;
    bottom: 0px;
    width: 0.15rem;
    height: 100%;
    transition: all 0.5s;
  }
  .arrow::before {
    left: -5px;
    transform: rotate(45deg);
    background-color: #394a6d;
  }
  .arrow::after {
    left: 5px;
    transform: rotate(-45deg);
    background-color: #394a6d;
  }
  .open .arrow::before {
    left: -5px;
    transform: rotate(-45deg);
  }
  .open .arrow::after {
    left: 5px;
    transform: rotate(45deg);
  }
`;
